import React from "react";

const DialogsUsers = ({id, correspondence, img, name, activeUser, exitOnInterlocutors}) => {
    return(
        <ul className={"dialogs__interlocutor" + (id === activeUser ? " active-interlocutor": "")} onClick={() => correspondence(id, exitOnInterlocutors)}>
            <div><img src={img} alt=""/></div>
            <div className="dialogs__interlocutor-name main-text"><p>{name}</p></div>
        </ul>
    )
};

export default DialogsUsers